import Vue from 'vue';
import Vuex from 'vuex';

import ErrorModule from '@/store/modules/ErrorModule';
import ProjectModule from '@/store/modules/ProjectModule';
import LocationModule from '@/store/modules/LocationModule';
import CustomerModule from '@/store/modules/CustomerModule';
import SuccessModule from '@/store/modules/SuccessModule';
import MarkersFilteringModule from '@/store/modules/MarkersFilteringModule';
import OverLayModule from '@/store/modules/OverLayModule';

import { getModule } from 'vuex-module-decorators';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    ErrorModule,
    SuccessModule,
    ProjectModule,
    LocationModule,
    CustomerModule,
    MarkersFilteringModule,
    OverLayModule
  }
});

export default store;

getModule(ErrorModule, store);
getModule(CustomerModule, store);
getModule(ProjectModule, store);
getModule(LocationModule, store);
getModule(SuccessModule, store);
getModule(MarkersFilteringModule, store);
getModule(OverLayModule, store);
